import { render, staticRenderFns } from "./DeductionTypes.vue?vue&type=template&id=32b8cc14&scoped=true"
import script from "./DeductionTypes.vue?vue&type=script&lang=js"
export * from "./DeductionTypes.vue?vue&type=script&lang=js"
import style0 from "./DeductionTypes.vue?vue&type=style&index=0&id=32b8cc14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b8cc14",
  null
  
)

export default component.exports